export default __webpack_public_path__ + "static/media/Filter.ace502c4.svg";